









































































































// import { mapState } from 'vuex'
import Vue from 'vue'
import dayjs from 'dayjs'
import moment from 'moment'
import { state } from '../store'
export default Vue.extend({
  name: '',
  props: {
    dayoffList: {
      default: () => [],
    },
    year: {
      default: 0,
    },
  },
  data() {
    return {
      type: 1,
      rule: 1,
      duration: 1,
      interval: 1,
      shift: '',
      range: [],
      shiftList: [],
      tabList: [
        { key: 'rule', tab: this.$t('page_console_calendar_rule') },
        { key: 'interval', tab: this.$t('page_console_calendar_interval') },
      ],
      tabKey: 'rule',
    }
  },
  watch: {
    year: {
      handler(year) {
        if (year === moment().year()) {
          this.range = [moment(), moment(`${year}/12/31`)]
        } else {
          this.range = [moment(`${year}/1/1`), moment(`${year}/12/31`)]
        }
      },
      immediate: true,
    },
  },
  created() {
    state.shiftList.subscribe(res => {
      this.shiftList = res
      this.shift = this.shiftList.length ? this.shiftList[0].code : ''
    })
  },
  beforeDestroy() {
    this.$bus.$off('year-changed')
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    changeType(e) {
      this.type = e.target.value
    },
    changeRange() {
      if (this.type === 2) {
        this.onType2PropsChange()
      }
    },
    changeRule() {
      return
    },
    changeDuration(val) {
      // this.onType2PropsChange()
    },
    changeInterval() {
      // this.onType2PropsChange()
    },
    select(param) {
      const [start, end] = this.range
      let current = dayjs(start.format('YYYY-MM-DD'))
      const result = []
      while (current.valueOf() <= end.valueOf()) {
        if (param.indexOf(current.day()) !== -1) {
          // 根据选择假期规律做进一步筛选

          if (this.rule === 1) {
            result.push(current.valueOf())
          }
          // if (this.rule === 2) {
          //   if (this.dayoffList.indexOf(current.valueOf()) === -1) {
          //     result.push(current.valueOf())
          //   }
          // }
          // if (this.rule === 3) {
          //   if (this.dayoffList.indexOf(current.valueOf()) !== -1) {
          //     result.push(current.valueOf())
          //   }
          // }
        }
        current = current.add(1, 'day')
      }
      this.$bus.$emit('select-day', result)
      console.log('emit')
    },
    // 按间隔中改变任一属性后的操作
    onType2PropsChange() {
      this.$bus.$emit('cancel-select')
      const [start, end] = this.range
      let current = dayjs(start.format('YYYY-MM-DD'))
      const result = []
      let count = 0
      while (current.valueOf() <= end.valueOf()) {
        if (count < this.duration) {
          result.push(current.valueOf())
          count++
          current = current.add(1, 'day')
        } else {
          count = 0
          current = current.add(this.interval, 'day')
        }
      }
      this.$bus.$emit('select-day', result)
    },
    // 添加班次
    arrange() {
      if (!this.shift) {
        this.$message.error(this.$t('page_calendar_select_shift'))
        return
      }
      const shift = this.shiftList.find(item => item.code === this.shift)
      this.$bus.$emit('arrange-days', {
        id: shift.id,
        name: shift.name,
        colour: shift.colour,
      })
    },

    cancelArrange() {
      this.$bus.$emit('cancel-arrange')
    },
    // 重置选择
    reset() {
      this.$bus.$emit('reset-days')
    },
    // 取消所有选择
    cancelSelect() {
      this.$bus.$emit('cancel-select')
    },

    setPriority() {
      this.$bus.$emit('set-priority')
    },

    cancelPriority() {
      this.$bus.$emit('cancel-priority')
    },

    onTabChange(key) {
      this.tabKey = key
    },
  },
})
